var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.eventList),function(item,index){return _c('ly-form-item',{key:index,attrs:{"label":item.label}},[_vm._v("\n        "+_vm._s(item.processResult)+"\n        "),_c('imgList',{attrs:{"data":item.picList}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b12d2b9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaodu/jincheng/event.vue
// module id = null
// module chunks = 